export const CONNECTION_START: 'CONNECTION_START' = 'CONNECTION_START';
export const CONNECTION_CLOSE: 'CONNECTION_CLOSE' = 'CONNECTION_CLOSE';
export const CONNECTION_CLOSED: 'CONNECTION_CLOSED' = 'CONNECTION_CLOSED';
export const CONNECTION_ERROR: 'CONNECTION_ERROR' = 'CONNECTION_ERROR';
export const CONNECTION_SUCCESS: 'CONNECTION_SUCCESS' = 'CONNECTION_SUCCESS';

export const GET_MESSAGE: 'GET_MESSAGE' = 'GET_MESSAGE';
export const SEND_MESSAGE: 'SEND_MESSAGE' = 'SEND_MESSAGE';